import React from 'react'
import FormField from './Forms/FormField'

const NameFieldsRow = ({ firstName, lastName, onChange }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <FormField
        type="text"
        name="firstName"
        value={firstName}
        onChange={onChange}
        label="First Name"
        placeholder="John"
        required
      />
      <FormField
        type="text"
        name="lastName"
        value={lastName}
        onChange={onChange}
        label="Last Name"
        placeholder="Doe"
        required
      />
    </div>
  )
}

export default NameFieldsRow